import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateUUID(): string {
  // Use crypto.randomUUID if available
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback implementation for environments without crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

let nodeIdCounter = 0;

/**
 * Generate a unique node ID with the standard format: {type}_{timestamp}_{counter}
 * This format is used throughout the app for consistent node identification.
 * The counter avoids collisions when multiple nodes are created within the same millisecond.
 */
export function generateNodeId(type: string): string {
  return `${type}_${Date.now()}_${nodeIdCounter++}`;
}
